// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { ServiceConfiguration, ServiceProvider } from '@centecomm/portal-service-react';
import React, { ReactNode } from 'react';

type CoreProviderConfigProps = {
    children: ReactNode;
    token: string;
};

const CoreProviderConfig: React.FC<CoreProviderConfigProps> = ({ children, token }: CoreProviderConfigProps) => {
    const serviceConfig = React.useMemo<ServiceConfiguration>(
        () => ({
            apiRoot: API_ROOT || '',
            options: {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            },
            dev: {
                // Use `currentUserPermissionsOverride` to override the backend permissions.
                // Example (additive — grant an extra permission locally):
                // currentUserPermissionsOverride: {
                //     mode: 'additive',
                //     permissions: {
                //         viewDocuments: {
                //             isSiteWide: true,
                //             occupantIds: [],
                //             propertyIds: [],
                //         },
                //     } as CurrentUserPermissions,
                // },
                //
                // Simulate a tenant non-admin (strip custom compliance view):
                // currentUserPermissionsOverride: {
                //     mode: 'subtractive',
                //     permissions: {
                //         viewCustomCompliance: {
                //             isSiteWide: true,
                //             occupantIds: [],
                //             propertyIds: [],
                //         },
                //         submitCustomCompliance: {
                //             isSiteWide: true,
                //             occupantIds: [],
                //             propertyIds: [],
                //         },
                //     } as CurrentUserPermissions,
                // },
            },
        }),
        [token],
    );

    return <ServiceProvider configuration={serviceConfig}>{children}</ServiceProvider>;
};

export default CoreProviderConfig;
